import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import FormCollapsibleColumn from 'components/p5/FormCollapsibleColumn'
import { NctsError } from 'shared/ncts/types'
import { useNctsErrors } from 'features/declaration/form/contexts/NctsErrorContext'

type NctsErrorRow = {
  uuid: string
  nctsError: NctsError
}

function NctsErrors() {
  const { t } = useTranslation()
  const { state: { errors } } = useNctsErrors()

  const [rows, setRows] = useState<NctsErrorRow[]>([])

  useEffect(() => {
    if (!errors) return
    setRows(errors.map((nctsError) => ({
      uuid: crypto.randomUUID(),
      nctsError,
    })))
  }, [errors])

  return (
    <section className="py-3">
      <FormCollapsibleColumn
        columnId="declaration-errors"
        headingLabel={t('declaration.p5.errors.title')}
        key={errors.length}
      >
        {
          !!rows.length && rows.map((row) => (
            <div className="row" key={`${row.uuid}`}>
              <div className="col-12">
                <div className="alert alert-danger d-noxne">
                  <span>{row.nctsError.path}</span>
                  <span className="ms-2">{row.nctsError.message}</span>
                  {row.nctsError.code && <span className="ms-2">{`[${row.nctsError.code}]`}</span>}
                </div>
              </div>
            </div>
          ))
        }
        {
          !rows.length && (
            <div className="row">
              <div className="col-12">
                <div className="no-warnings d-block text-center">{t('declaration.p5.errors.none')}</div>
              </div>
            </div>
          )
        }
      </FormCollapsibleColumn>
    </section>
  )
}

export default NctsErrors
